import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { EmployeeDismissalsDto } from "../../../../dtos/documents/EmployeeDismissals/EmployeeDismissalsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFPlainText } from "../../../Shared/NewForms/NFPlainText";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupPerson } from "../../../Shared/NewForms/NFlookupPerson";
import { EmployeeDismissalsModel } from "../../../../models/Documents/EmployeeDismissals/EmployeeDismissalsModel";
import { NFLookupFeature } from "../../../Shared/NewForms/NFLookupFeature";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFLookupEmployee } from "../../../Shared/NewForms/NFLookupEmployee";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import EmployeeDismissalsDetailSkeleton from "./EmployeeDismissalsDetailSkeleton";
import { EmployeeDismissalsDetalFooter } from "./EmployeeDismissalsDetalFooter";
interface IProps {
  model: EmployeeDismissalsDto | null;
  modelUpdatedEvent: (newModel: EmployeeDismissalsDto) => void;
}

export const EmployeeDismissalsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<EmployeeDismissalsModel>();
  const [tabIndex, setTabIndex] = useState(0);

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  // const watchProducts = watch("postingOfGoodGoods");
  const [fileName, setFileName] = useState("Employee DIsmissals");

  useEffect(() => {
    console.log(model);
    // register("postingOfGoodGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("departureDate", model.departureDate);
      setValue("personId", model.personId);
      setValue("companyId", model.companyId);
      setValue("employeeId", model.employeeId);
      setValue("createdDate", model.createdDate);
    }
  }, [model]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: EmployeeDismissalsModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: EmployeeDismissalsDto = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: EmployeeDismissalsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <EmployeeDismissalsDetailSkeleton />
      </>
    );
  }
  const handleUploadFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryString = event.target?.result;
      const workbook = XLSX.read(binaryString, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const worksheetData: any = XLSX.utils.sheet_to_json(worksheet, {
        header: 1
      });
      const documentNumber = worksheetData[1][0];
      const personId = worksheetData[1][1];
      const companyId = worksheetData[1][2];
      const employeeId = worksheetData[1][3];

      setValue("documentNumber", documentNumber);
      setValue("personId", personId);
      setValue("companyId", companyId);
      setValue("employeeId", employeeId);
    };
    reader.readAsBinaryString(file);
  };

  const exportToExcel = () => {
    try {
      const data = {
        documentNumber: model.documentNumber,
        personId: model.personId,
        companyId: model.companyId,
        employeeId: model.employeeId
      };
      const ws = XLSX.utils.json_to_sheet([data]);
      console.log("data", data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const exportFileName = `${fileName}.xls`;
      XLSX.writeFile(wb, exportFileName);
      setFileName(exportFileName);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} required={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Departure Date"} fieldName={"departureDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupPerson fieldName={"personId"} title={"Person"} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupEmployee fieldName={"employeeId"} title={"Employee"} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <EmployeeDismissalsDetalFooter/>
    </FormProvider>
  );
};
